import React from 'react';

export default function ConfirmModal({
  isOpen,
  title = 'Confirm Action',
  message = 'Are you sure?',
  actionLabel = 'Delete',
  actionColor = 'danger',
  onConfirm,
  onCancel,
  isDangerous = true,
}) {
  if (!isOpen) return null;

  const actionBtnClass = `btn btn-${actionColor}`;

  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && onCancel()}>
      <div className="modal" style={{ maxWidth: 450 }}>
        <div className="modal-header">
          <h3 className="modal-title">{title}</h3>
          <button className="btn btn-secondary btn-sm btn-icon" onClick={onCancel}>✕</button>
        </div>

        <div style={{ padding: '20px 0', color: 'var(--iocl-light)', lineHeight: 1.6 }}>
          {message}
        </div>

        {isDangerous && (
          <div style={{
            padding: 12,
            marginBottom: 16,
            backgroundColor: 'rgba(220, 53, 69, 0.1)',
            border: '1px solid rgba(220, 53, 69, 0.3)',
            borderRadius: 4,
            color: 'var(--iocl-orange)',
            fontSize: 13,
          }}>
            ⚠️ This action cannot be undone.
          </div>
        )}

        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={onCancel}>Cancel</button>
          <button className={actionBtnClass} onClick={onConfirm}>{actionLabel}</button>
        </div>
      </div>
    </div>
  );
}
